<template>
    <v-dialog v-model="show" persistent max-width="600">
        <ToolBarModal />
        <v-card class="fill-height pt-2 pb-2" fluid>
            <v-container class="text-center">

                <div v-if="resentEmail == true">
                    <v-alert text color="success" class="mx-12" border="left">
                        <h3 class="text-h5 font-weight-bold">E-mail enviado com sucesso.</h3>
                        <div>Enviamos um link para seu e-mail, entre e clique no link para podermos criar sua senha. <br><br>Lembre de olhar a caixa de
                            <b>SPAM.</b>
                        </div>
                    </v-alert>
                    <router-link :to="{ path: '/' }" tag="v-btn">
                        <v-btn color="primary" width="25%" class="ma-2">
                            Fechar
                        </v-btn>
                    </router-link>
                </div>
                <div v-else-if="input.token">
                    <v-card class="mx-auto" max-width="800">
                        <v-card-title>
                            <v-icon large left> settings_applications </v-icon>
                            <span class="title font-weight-light">Criando senha de acesso.</span> {{ redirect }}
                        </v-card-title>
                        <v-card-text>
                            <v-form ref="form" v-model="valid" @submit.prevent="send">
                                <v-text-field v-model="input.email" label="E-mail" class="my-8" required disabled />
                                <v-text-field label="Digite a senha" v-model="input.password" min="8" :rules="[rules.required, rules.password]"
                                    :append-icon="show1 ? 'visibility' : 'visibility_off'" :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1" counter required />
                                <v-text-field label="Confirme a senha" v-model="confirmPassword" min="8" :rules="confirmPasswordRules"
                                    :append-icon="show2 ? 'visibility' : 'visibility_off'" :type="show2 ? 'text' : 'password'" @click:append="show2 = !show2" counter required />
                                <v-switch v-model="input.car" inset color="success" label="Usuário de carro elétrico" class="mb-0 pb-0" />
                                <v-switch v-model="input.bike" inset color="success" label="Usuário de bicicleta elétrica" class="mt-0 pb-0" />

                                <v-switch v-model="keep" inset color="success" label="Manter logado" dense class="mt-12" />
                                <v-layout justify-center align-center>
                                    <v-btn color="success" @click="send" :loading="sending" class="pa-4">Salvar</v-btn>
                                    <router-link :to="{ path: '/' }" tag="v-btn">
                                        <v-btn color="primary" class="ma-2">
                                            Fechar
                                        </v-btn>
                                    </router-link>
                                </v-layout>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </div>
                <div v-else>
                    <v-row dense>
                        <v-col cols="12">
                            <v-card color="primary" dark>
                                <v-card-title class="headline">Infelizmente o link está vencido.</v-card-title>

                                <v-card-subtitle>
                                    Para sua segurança o link de acesso tem validade de 30 minutos. Para concluir o cadastro clique em 'Reenviar' e verifique novamente seu e-mail.
                                </v-card-subtitle>

                                <v-card-actions>
                                    <v-btn color="success" @click="resend" :loading="sending">Reenviar</v-btn>
                                </v-card-actions>
                            </v-card>
                            <v-progress-linear v-if="sending" indeterminate />
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import jwt from "@/helpers/jwt";
import rules from "@/helpers/rules";

import ToolBarModal from "@/components/core/ToolBarModal.vue";

export default {
    components: { ToolBarModal },

    created() {
        this.$store.commit("CLEAR_LOGIN");
        if (this.$route.params.token) {
            this.input.email = jwt.get(this.$route.params.token, "email");
            if (jwt.checkToken(this.$route.params.token)) {
                this.redirect = jwt.get(this.$route.params.token, "redirect") || this.$store.state.routeBeforeRegister;
                this.input.token = this.$route.params.token;
            }
        }
    },

    data() {
        return {
            jwt,
            rules,
            valid: true,
            sending: false,
            confirmPassword: null,
            show: true,
            show1: false,
            show2: false,
            keep: true,
            redirect: "/",
            input: {
                email: null,
                password: null,
                token: null,
                car: true,
                bike: true,
            },
            confirmPasswordRules: [(v) => v === this.input.password || "Senha diferentes"],
            resentEmail: false,
        };
    },

    methods: {
        forceLogin() {
            this.sending = true;
            this.$http
                .post("api/v2/auth", this.input)
                .then((response) => {
                    this.$store.commit("SET_LOGIN", { response, email: this.input.email, remember: this.keep, password: this.keep ? this.input.password : null });

                    this.$emit("login");
                    this.$router.replace({ path: this.redirect });
                })
                .catch((error) => {
                    this.sending = false;
                    this.$eventHub.$emit("msgError", error.message ? error.message : "Usuário e/ou Senha incorretos.");
                    this.$router.replace({ path: "/login" });
                });
        },
        send() {
            if (this.$refs.form.validate()) {
                this.sending = true;
                this.$http
                    .post("api/v2/confirm-register", this.input)
                    .then((result) => {
                        this.sending = false;
                        this.$eventHub.$emit("msgSuccess", result.message ? result.message : "Cadastro concluído com sucesso.");
                        this.forceLogin();
                    })
                    .catch((error) => {
                        this.sending = false;
                        this.$eventHub.$emit("msgError", error.message ? error.message : "Não foi possível enviar sua solicitação.");
                    });
            }
        },
        resend() {
            this.sending = true;
            this.$http
                .post("api/v2/register", { email: this.input.email })
                .then(() => {
                    this.resentEmail = true;
                })
                .catch((error) => {
                    this.sending = false;
                    this.$eventHub.$emit("msgError", error.message ? error.message : "Não foi possível enviar sua solicitação.");
                });
        },
    },
};
</script>